import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=51bd5f1e&scoped=true&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=51bd5f1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd5f1e",
  null
  
)

export default component.exports